import { DeleteButton } from '../../../../../components/buttons/DeleteButton';
import { useTranslation } from 'react-i18next';

export const PartnerContractsTable = ({ contracts, onRemove }) => {

    const { t } = useTranslation('partner');

    return (
        <div className={'partner-contracts-form-table'}>
            <table>
                <thead>
                <tr>
                    <th className={'td'}>{t('contracts.number')}</th>
                    <th className={'td'} width={'20%'}>{t('contracts.validTill')}</th>
                    <th className={'td'}>{t('contracts.comment')}</th>
                    <th className={'td'}></th>
                </tr>
                </thead>
                <tbody>
                {contracts == null || contracts.length === 0 ? <></> : contracts.map((contract, index) => {
                    return (
                        <tr key={index}>
                            <td className={'td'}>{contract.code}</td>
                            <td className={'td'}>{contract.validTill}</td>
                            <td className={'td'}>{contract.comment}</td>
                            <td className={'td'}>
                                <DeleteButton onClick={() => onRemove(index)} />
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        </div>
    );
};